import { render, staticRenderFns } from "./ApprovalSubmissionHeader.vue?vue&type=template&id=3b87b48e&scoped=true&"
import script from "./ApprovalSubmissionHeader.vue?vue&type=script&lang=ts&"
export * from "./ApprovalSubmissionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalSubmissionHeader.vue?vue&type=style&index=0&id=3b87b48e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87b48e",
  null
  
)

export default component.exports